import type { TranslationTag } from '@ps/web-core-intl';
import type { ResultType } from '@ps/web-sports-api-types';

import {
  TXTWCL_Cashed_out,
  TXTWCL_Lost_Xshort_formX,
  TXTWCL_Placed_Xshort_formX,
  TXTWCL_Settled_1,
  TXTWCL_Void_Xshort_formX,
  TXTWCL_Won_Xshort_formX
} from './betStatusToTranslationTagMap.messages.json';

const betResultToTranslationTagMap: Record<ResultType, TranslationTag> = {
  PLACED: TXTWCL_Placed_Xshort_formX,
  WON: TXTWCL_Won_Xshort_formX,
  LOST: TXTWCL_Lost_Xshort_formX,
  VOID: TXTWCL_Void_Xshort_formX,
  SETTLED: TXTWCL_Settled_1,
  CASHED_OUT: TXTWCL_Cashed_out
};

export default betResultToTranslationTagMap;
